import { useTickets } from 'contexts/TicketsContext';

type UseScheduleListViewHeaderT = {
  handleCloseScheduleListView: () => void;
};

const useScheduleListViewHeader = (): UseScheduleListViewHeaderT => {
  const { setIsScheduleTicketList } = useTickets();

  const handleCloseScheduleListView = () => {
    setIsScheduleTicketList(false);
  };

  return {
    handleCloseScheduleListView,
  };
};

export default useScheduleListViewHeader;
